import { useEffect, useState } from 'react'
import { gql, useMutation } from '@apollo/client'

export const GET_GROUP_EVENT = gql`
  query ThingsToDoRegistrationGroupEvent($slug: String!) {
    groupEvents(slug: $slug) {
      id
      title
      slug
      startDateTime
      endDateTime
      paymentRecurrenceSchedule
      numberOfPayments
      description
      lessonCount
      hasWaitlist
      academy {
        slug
      }
      coachFacility {
        name
        street
        city
        zipCode
      }
      coach {
        id
        name
        externalId
        pgaCoachEligible
        hasPaidTierSubscription
        coachProfile {
          profilePhoto
          title
          memberType
          certificationLevel
        }
      }
      assistantCoaches {
        id
      }
      featuredImageUrl
      priceInCents
      totalPriceInCents
      isCanceled
      externalRegistrationUrl
      registrationClosed
      registrationFull
      registrationCount
      maxAttendance
      requiresAccessCode
      acceptsOnlinePayments
      timezone
      tags
      sessions {
        startDateTime
        endDateTime
      }
    }
  }
`

export const REGISTER_GROUP_EVENT = gql`
  mutation RegisterGroupEvent(
    $id: ID!
    $participants: [StudentAttributes!]!
    $contact: ContactAttributes
    $stripeToken: String
  ) {
    registerGroupEvent(
      id: $id
      participants: $participants
      contact: $contact
      stripeToken: $stripeToken
    ) {
      success
      message
    }
  }
`

const PREPARE_REGISTER_GROUP_EVENT = gql`
  mutation PrepareGroupEventPayment($input: PrepareRegisterGroupEventInput!) {
    prepareRegisterGroupEvent(input: $input) {
      success
      message
      code
      products {
        ... on Enrollment {
          student {
            contact {
              email
            }
          }
        }
      }
      paymentIntent {
        clientSecret
        amount
        metadata {
          operation
          args
          lineItems {
            amountInCents
            label
            collect
          }
        }
      }
    }
  }
`

export const useGetClientSecret = ({
  groupEventId,
  participants,
  contact,
  enabled = false,
}) => {
  const [clientSecret, setClientSecret] = useState(null)
  const [prepareRegisterGroupEvent, { data, loading, error }] = useMutation(
    PREPARE_REGISTER_GROUP_EVENT,
  )

  useEffect(() => {
    if (
      enabled &&
      groupEventId &&
      participants?.length > 0 &&
      contact?.lastName &&
      contact?.firstName
    ) {
      setClientSecret(null) // Reset clientSecret when starting new request
      prepareRegisterGroupEvent({
        variables: {
          input: {
            id: groupEventId,
            participants,
            contact,
          },
        },
      })
    }
  }, [enabled, groupEventId, participants, contact, prepareRegisterGroupEvent])

  useEffect(() => {
    if (data?.prepareRegisterGroupEvent?.success) {
      setClientSecret(
        data?.prepareRegisterGroupEvent?.paymentIntent?.clientSecret,
      )
    }
  }, [data])

  return { clientSecret, loading, error }
}

export const usePrepareRegisterGroupEvent = () => {
  const [prepareRegisterGroupEvent, { loading, error }] = useMutation(
    PREPARE_REGISTER_GROUP_EVENT,
  )

  return { prepareRegisterGroupEvent, loading, error }
}
